import Api from '@/script/api';
import lodash from 'lodash';

const state = {
    cate_options: [],
    select: [],
};

const mutations = {
    SET_SELECT(state, { item, level }) {
        // 克隆当前选中列表
        const temp = lodash.clone(state.select);

        // 截取前 level - 1 项
        const newSelect = temp.slice(0, level - 1);

        // 替换第 level 项
        newSelect.push(item);

        // 更新 state
        state.select = newSelect;
    },
    SET_CATE_OPTIONS(state, options) {
        state.cate_options = options;
    },
    SET_NODE_CHILDREN(state, { node, children }) {
        node.children = children;
    }
};

const actions = {
    // 异步操作
    async loadChildrenForSelected({ commit, state }) {
        let selectedList = state.select;
        let parent_id = selectedList[selectedList.length - 1]?.cid || 0;

        const res = await Api.post('/admintooltaobaoaccount/getdoudiancategorybyparentid', { parent_id });
        if (res.code == 1 && res.info?.length) {

            let currentLevel = state.cate_options;
            let currentNode = null;
            let children = res.info.map(info => {
                return {
                    ...info,
                    children: []
                }
            });

            for (const item of selectedList) {
                currentNode = currentLevel.find(c => c.cid === item.cid);
                if (!currentNode) {
                    return;
                }

                currentLevel = currentNode?.children || [];
            }
            if (currentNode) {
                commit('SET_NODE_CHILDREN', { node: currentNode, children })
            } else {
                commit('SET_CATE_OPTIONS', children)
            }
        }
    },
    categorySearch(context, keyword) {
        return Api.post('/admintooltaobaoaccount/getdoudiancategorysearch', { keyword })
    }
};

const getters = {};

export default {
    namespaced: true, // 推荐开启命名空间
    state,
    mutations,
    actions,
    getters,
};
